import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/notification_table'
import PushNotificationsService from '../../network/services/notification'
import { serialize } from '../../network/request'
import PushNotificationsTable from './PushNotificationTable'

const PushNotificationsPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Push Notifications
    </Button>
  )

  return (
    <PageHeader title="All Push Notifications" extra={[primaryAction]}>
      <Card>
        <PushNotificationsTableWrapper />
      </Card>
    </PageHeader>
  )
}

const PushNotificationsTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(PushNotificationsService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  console.log(response)

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = PushNotificationsService.toPaginate(response)

  return (
    <>
      <PushNotificationsTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <PushNotificationsTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default PushNotificationsPage
